import type { KeyWithFilter } from '@/utils/filter/filter';

export const filters = (): KeyWithFilter[] => [
    {
        key: ['name'],
        type: 'input',
        value: [],
    },
    {
        key: [
            {
                key: 'installationDate',
                trans: 'installationDate',
                defaultOperator: '=',
            },
        ],
        type: 'date',
        value: [],
    },
];
